import { render, staticRenderFns } from "./companyModal.vue?vue&type=template&id=3f5ace0a&scoped=true"
import script from "./companyModal.vue?vue&type=script&lang=js"
export * from "./companyModal.vue?vue&type=script&lang=js"
import style0 from "./companyModal.vue?vue&type=style&index=0&id=3f5ace0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ace0a",
  null
  
)

export default component.exports